import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_warehouse_node_type_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    warehouse_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    node_type: fromDatatype.VarcharDatatypeInterface;
    total_x: fromDatatype.NumericDatatypeInterface;
    total_y: fromDatatype.NumericDatatypeInterface;
    total_z: fromDatatype.NumericDatatypeInterface;
    dim_x: fromDatatype.NumericDatatypeInterface;
    dim_y: fromDatatype.NumericDatatypeInterface;
    dim_z: fromDatatype.NumericDatatypeInterface;
    dim_max_weight: fromDatatype.NumericDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_wms_warehouse_node_type_hdr_RowClass implements bl_wms_warehouse_node_type_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    warehouse_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    node_type: fromDatatype.VarcharDatatypeInterface;
    total_x: fromDatatype.NumericDatatypeInterface;
    total_y: fromDatatype.NumericDatatypeInterface;
    total_z: fromDatatype.NumericDatatypeInterface;
    dim_x: fromDatatype.NumericDatatypeInterface;
    dim_y: fromDatatype.NumericDatatypeInterface;
    dim_z: fromDatatype.NumericDatatypeInterface;
    dim_max_weight: fromDatatype.NumericDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}